import React, { useEffect, useState } from 'react'
import Loader from 'react-loader-spinner'
import styled from 'styled-components'

import DefaultLogo from 'assets/icons/rfp_logo.svg'
import { theme } from 'styles/theme'

const Img = styled.img`
  max-height: 38px;
`

export default function Logo({ logoURL }: { logoURL: string }) {
  const [isLoaded, setLoaded] = useState(false)
  const [isValid, setValid] = useState(false)

  useEffect(() => {
    const img = new Image()
    img.onload = () => [setValid(true), setLoaded(true)]
    img.onerror = () => [setValid(false), setLoaded(true)]
    img.src = logoURL
  }, [logoURL])

  if (!logoURL || isLoaded) {
    return <Img src={logoURL && isValid ? logoURL : DefaultLogo} alt="Logo" />
  }

  return (
    <Loader type="TailSpin" width={30} height={30} color={theme.colors.main} />
  )
}
